import { render } from "./accessibility.vue?vue&type=template&id=c6af296e&ts=true"
import script from "./accessibility.vue?vue&type=script&lang=ts"
export * from "./accessibility.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__